import { render, staticRenderFns } from "./OMinisterio.vue?vue&type=template&id=38a95714&scoped=true&"
var script = {}
import style0 from "./OMinisterio.vue?vue&type=style&index=0&id=38a95714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a95714",
  null
  
)

export default component.exports